<div flex layout-align="space-between center" layout="row">
  @if (data.title) {
    <div mat-dialog-title>
      <p>{{ data.title }}</p>
    </div>
  }
  <button tabindex="-1" mat-icon-button (click)="onNoClick()">
    <mat-icon>clear</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <p class="dialog-message">
    <span [innerHtml]="data.message"></span>
    @if (data.warningMessage) {
      <span>
        <div>
          <mat-hint [style.color]="'#dc3545'">{{ data.warningMessage }}</mat-hint>
        </div>
      </span>
    }
  </p>
</div>
<mat-progress-bar
  mode="determinate"
  [value]="data.progressBarValue"
></mat-progress-bar>
@if (data.expandingMessage) {
  <mat-expansion-panel (opened)="expandingMessageOpen = true"
    (closed)="expandingMessageOpen = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ data.expandingMessage.title }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    {{ data.expandingMessage.message }}
  </mat-expansion-panel>
}
